module.exports = __webpack_public_path__ + "static/media/icon_phone.fc883f6a.svg";